<template>
  <v-card-text
    class="pa-0 d-flex flex-column"
    style="height: 90%;min-height: 600px;"
  >
    <Questions
      ref="sq33q0"
      @goToNextQuestion="goToNextQuestion"
      :secondRadioB="true"
      :dataSeted="dataSeted"
      :question="questionData.questions[0]"
      :screens_question="questionData.question"
      :sq_aclaration="questionData.aclaration"
      @sendAnswer="chooseOption"
    ></Questions>
    <Questions
      ref="sq33q1"
      @goToNextQuestion="goToNextQuestion"
      :isCurrency="false"
      :dataSeted="dataSeted"
      :question="questionData.questions[1]"
      :screens_question="null"
      :sq_aclaration="null"
      @sendAnswer="answerOfClient"
      @changeDataSeted="changeDataSeted"
    ></Questions>
    <Questions
      ref="sq33q2"
      @goToNextQuestion="goToNextQuestion"
      :dataSeted="dataSeted"
      :btnWidth="210"
      :question="questionData.questions[2]"
      :screens_question="null"
      :sq_aclaration="null"
      @selectOption="reportIfClientUndertands"
      :class="!showButton ? 'mb-16 pb-16' : 'mb-0'"
    ></Questions>
    <transition name="ques">
      <NextQuestionButton
        class="pb-16"
        v-if="showButton"
        @goToNextQuestion="goToNextQuestion"
      ></NextQuestionButton>
    </transition>
  </v-card-text>
</template>

<script>
import Questions from '@/components/savings/blocks/Questions'
import NextQuestionButton from '@/components/savings/blocks/NextQuestionButton'
import { mapGetters } from 'vuex'
import { answerData } from '@/mixins/answerData'
import Helper from '../../../../helpers/Helper'

export default {
  name: 'SQuesThirtyThree',
  components: {
    Questions,
    NextQuestionButton
  },
  props: {
    questionData: Object
  },
  data () {
    return {
      showButton: false,
      dataSeted: false,
      question0: '',
      question1: '',
      decisionQuestionFirstValue: '',
      historyFirstValue: [],
      historyScrap: [],
      deleteData: [],
      sq_data: [
        {
          question_id: this.questionData.questions[0].id,
          ponderation: '',
          updated_at: ''
        },
        {
          question_id: this.questionData.questions[1].id,
          ponderation: '',
          updated_at: ''
        },
        {
          question_id: this.questionData.questions[2].id,
          ponderation: '',
          updated_at: ''
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getOperationNumber',
      'scoringData',
      'isBrowsingInScoringHistory',
      'continueScoring',
      'getIndexOfCurrentSQ',
      'getHistory',
      'SQNameByNumber',
      'sq_number'
    ])
  },
  methods: {
    setData (sqdata) {
      if (this.scoringData[sqdata] !== null) {
        this.showButton = true
        this.dataSeted = true
        this.$emit('handleProgress', 74)
        this.$refs.sq33q0.setAnswer(this.scoringData[sqdata][0].ponderation)
        this.$refs.sq33q1.setAnswer(this.scoringData[sqdata][1].ponderation)
        this.$refs.sq33q2.setAnswer(this.scoringData[sqdata][2].ponderation)
        for (let i = 0; i < 3; i++) {
          this.sq_data[i].ponderation = this.scoringData[sqdata][i].ponderation
          this.sq_data[i].updated_at = this.scoringData[sqdata][i].updated_at
          if (this.continueScoring) {
            if (this.scoringData[sqdata][0].id !== undefined) {
              this.sq_data[i].id = this.scoringData[sqdata][i].id
            }
          }
        }
        if (this.isBrowsingInScoringHistory) {
          this.question0 = this.scoringData[sqdata][0].ponderation
          this.question1 = this.scoringData[sqdata][1].ponderation
          this.decisionQuestionFirstValue = this.scoringData[
            sqdata
          ][2].ponderation
          this.historyFirstValue = this.getHistory
        }
      }
    },
    chooseOption (value) {
      this.sq_data[0].ponderation = value
      this.sq_data[0].updated_at = Helper.setDateAndTime()
    },
    answerOfClient (value) {
      this.sq_data[1].ponderation = value
      this.sq_data[1].updated_at = Helper.setDateAndTime()
    },
    reportIfClientUndertands (value) {
      this.dataFromQuestions(value, 2)
    },
    goToNextQuestion () {
      if (this.isBrowsingInScoringHistory) {
        this.handleIfEditDecisionQues(0, this.question0)
        this.handleIfEditDecisionQues(1, this.question1)
        this.$emit('reduceDecreasing', 1)
        if (this.decisionQuestionFirstValue !== this.sq_data[2].ponderation) {
          this.$emit('reduceDecreasing', 0)
          this.handleIfEditDecisionQues(2, this.decisionQuestionFirstValue)
          this.historyScrap = this.historyFirstValue.splice(
            this.getIndexOfCurrentSQ + 1
          )
          this.historyScrap.forEach(e => {
            if (e !== 2 && e !== 32 && e !== 41) {
              if (this.scoringData[this.SQNameByNumber[e]] !== null) {
                if (
                  this.scoringData[this.SQNameByNumber[e]][0].id === undefined
                ) {
                  this.$store.dispatch('handleResetScoringData', e)
                } else {
                  this.scoringData[this.SQNameByNumber[e]].forEach(q => {
                    this.deleteData.push(q.id)
                  })
                  this.$store.dispatch('handleResetScoringData', e)
                }
              }
            }
          })
          this.$emit('deleteQuestion', this.deleteData)
          this.$store.dispatch('handleHistoryData', this.historyFirstValue)
          this.$store.dispatch('handleIfIsBrowsingInScoringHistory', false)
          this.$store.dispatch('handleHistoryIndexOfCurrentSQ', null)
        }
      }
      this.$store.dispatch('handleScoringData', this.sq_data)
      if (
        this.sq_data[2].ponderation ===
        this.questionData.questions[2].options[0]
      ) {
        this.$emit('handleProgress', 75)
        if (this.isBrowsingInScoringHistory) {
          this.$store.dispatch('handleOnlyCurrentSQ', 13)
        } else {
          this.$store.dispatch('handleCurrentSQ', 13)
        }
      } else {
        if (this.isBrowsingInScoringHistory) {
          this.$store.dispatch('handleOnlyCurrentSQ', 34)
        } else {
          this.$store.dispatch('handleCurrentSQ', 34)
        }
      }
      this.$emit('checkIfHistoryModeContinues')
    }
  },
  mixins: [answerData],
  mounted () {
    this.setData('sq_thirtyTreeData')
  }
}
</script>

<style lang="scss" scoped>
.ques-enter-active {
  transition: opacity 0.5s;
}
.ques-enter {
  opacity: 0;
}
</style>
